import Icon from '../components/Icon.vue'

Icon.register({
  ad: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M157.5 272l18.5-53.2 18.5 53.2h-37zM352 256c13.2 0 24 10.8 24 24s-10.8 24-24 24-24-10.8-24-24 10.8-24 24-24zM464 64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-288c0-26.5 21.5-48 48-48h416zM250.6 352c11 0 18.7-10.8 15.1-21.3l-53.7-154.6c-3.1-8.9-13.2-16.1-22.7-16.1h0-26.7 0c-9.4 0-19.6 7.2-22.7 16.1l-53.7 154.6c-3.6 10.4 4.1 21.3 15.1 21.3h16.9 0c6.3 0 13.1-4.8 15.1-10.8l7.4-21.3h70.3l7.4 21.3c2.2 6.4 8.3 10.8 15.1 10.8h16.9zM424 336v-160c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v36.4c-7.5-2.7-15.5-4.4-24-4.4-39.7 0-72 32.3-72 72s32.3 72 72 72c9.9 0 19.4-2 28-5.7 2.9 3.4 7.1 5.7 12 5.7h16c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/ad.js
// module id = 960
// module chunks = 0